/* @flow */
import { reducer, initialState } from 'payments/reducers/Transactions';
import { ReduceStore } from 'flux/utils';
import { dispatcher } from 'lib/Dispatcher';
import Transactions from 'collections/Transactions';

class TransactionStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getSentPayments() {
    return new Transactions(
      this.getState().transactions.models.filter(
        tr => tr.isPaymentSent()
      )
    );
  }

  getTransactions() {
    return this.getState().transactions;
  }

  getTransactionById(id) {
    return this.getState().transactions.get(id);
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new TransactionStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/TransactionStore.js